module.exports = __webpack_public_path__ + "static/img/mmsLogo.e4261c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/mmsLogo.png
// module id = DG3X
// module chunks = 2